import { FC, useState } from "react"
import Plus from '../../assets/FrequentQuestions/plus.png'

const FrequentQuestions : FC = () => {
  const FREQUENT_QUESTIONS = [
    {
      question: 'Что необходимо предоставить',
      answer:
      <ul>
        <li>Чертеж / план помещения в формате .dwg или .pdf;</li>
        <li>тип и высота потолков;</li>
        <li>ваши пожелания.</li>
      </ul>,
    },
    {
      question: 'Сколько делается расчет освещения',
      answer: <p>От 1 до 3 дней в зависимости от сложности проекта.</p>,
    },
    {
      question: 'Этапы работ',
      answer:
      <ol>
        <li>Подать заявку на расчет освещения</li>
        <li>Обсуждение проекта</li>
        <li>Получение готового светотехнического расчета</li>
      </ol>,
    },
  ]

  return <div className='container frequent-questions'>
    {FREQUENT_QUESTIONS.map(({ question, answer }, index) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const [isAnswerOpen, setIsAnswerOpen] = useState<boolean>(false)
      return (
        <div className="row justify-content-between question" key={index}>
          <div className="col d-flex">
            <div className="col d-flex flex-column justify-content-center">
              <h4
                className={`question__question ${
                  isAnswerOpen
                    ? 'question__question--open'
                    : 'question__question--close'
                }`}
                onClick={() => {
                  setIsAnswerOpen((prev) => !prev)
                }}
              >
                {question}
              </h4>
              <div
                className={`question__answer ${
                  isAnswerOpen
                    ? 'question__answer--open'
                    : 'question__answer--close'
                }`}
              >
                {answer}
              </div>
            </div>
          </div>
          <div className="col-1 p-0 d-flex justify-content-end">
            <img
              alt='plus'
              src={Plus}
              className={`${
                isAnswerOpen
                  ? 'question__close--open'
                  : 'question__close--close'
              }`}
              onClick={() => {
                setIsAnswerOpen((prev) => !prev)
              }}
            />
          </div>
        </div>
      )
    })}
  </div>
}

export default FrequentQuestions;
